export function redirectLabel(value?: string) {
  return value === '1' ? 'redirecionamento' : 'redirecionamentos'
}

export function sourceLabel(value?: string) {
  return value === '1' ? 'origem identificada' : 'origens identificadas'
}

export function declaredPageComparison(declaredPage?: string | null, sourcePage?: string | null) {
  if (!declaredPage) return 'Landing page não cadastrada'
  if (!sourcePage) return 'Origem não informada; comparação indisponível'
  try {
    const declared = new URL(declaredPage)
    const source = new URL(sourcePage)
    return declared.hostname === source.hostname
      ? 'Mesmo domínio da landing page declarada'
      : 'Domínio diferente da landing page declarada'
  } catch {
    return 'Comparação indisponível'
  }
}
